import React, { useEffect, useState, useRef } from "react";
import {
  bp_add_meta_data,
  bp_get_machine_by_machine_typ,
  bp_machine_data,
  delete_product,
  bp_save_batch_product_inventory,
} from "../../../utils/api";
import { toast } from "react-toastify";
import { Input, Select, Button, Descriptions } from "antd";
import DataTable from '@/components/DataTable';
import { Plus, Trash2 } from "lucide-react";
import MainCard from '@/components/MainCard';
import { batch, useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { defaultColors } from '@/themes/antd-theme';

function Product() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const operation_data = state?.operation_data;
  const dispatch = useDispatch();
  const [machine, set_machine] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    submit_function();
  };

  const delete_product_data = async (params) => {
    try {
      await delete_product({ id: params?.product_id }, success_delete_product);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_delete_product = (res) => {
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      toast.success(res.message);
    }
  };

  const submit_function = async () => {
    try {
      await bp_save_batch_product_inventory(
        {
          operation_id: operation_data?.operation_id,
          product_id: operation_data?.products[0].product_id,
          machine_id: machine,
          batch_number: operation_data?.batch_number,
          container_inventory: added_data,
        },
        success_bp_save_batch_product_inventory
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_bp_save_batch_product_inventory = (res) => {
    console.log(res);
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      navigate("/batch");
      toast.success("Metadata added Successfully");
    }
  };

  const [added_data, set_added_data] = useState([
    {
      container_id: "",
      tara_weight: "",
      gross_weight: "",
      net_weight: "",
    },
  ]);

  useEffect(() => {
    console.log("added_data", added_data);
  }, [added_data]);

  const machineDetailColumns = [
    {
      dataIndex: "container_id",
      title: <span className="text-lg font-bold">Container No</span>,
      align: "center",
      key: "container_id",
      render: (_, __, index) => (
        <Input
          type="text"
          size="large"
          value={added_data[index]?.container_id}
          onChange={(e) => {
            let temp = [...added_data];
            temp[index]["container_id"] = e.target.value;
            set_added_data(temp);
          }}
          style={{
            fontSize: "24px",
          }}
        />
      ),
    },
    {
      dataIndex: "tara_weight",
      title: <span className="text-lg font-bold">Tare Weight</span>,
      align: "center",
      key: "tara_weight (Wt)",
      render: (_, __, index) => (
        <Input
          type="text"
          size="large"
          value={added_data[index]?.tara_weight}
          onChange={(e) => {
            let temp = [...added_data];
            temp[index]["tara_weight"] = e.target.value;
            set_added_data(temp);
          }}
          style={{
            fontSize: "24px",
          }}
        />
      ),
    },
    {
      dataIndex: "gross_weight",
      title: <span className="text-lg font-bold">Gross Weight</span>,
      align: "center",
      key: "gross_weight (Wt)",
      render: (_, __, index) => (
        <Input
          type="text"
          size="large"
          value={added_data[index]?.gross_weight}
          onChange={(e) => {
            let temp = [...added_data];
            temp[index]["gross_weight"] = e.target.value;
            set_added_data(temp);
          }}
          style={{
            fontSize: "24px",
          }}
        />
      ),
    },
    {
      dataIndex: "net_weight",
      title: <span className="text-lg font-bold">Net Weight</span>,
      align: "center",
      key: "net_weight (Wt)",
      render: (_, __, index) => (
        <Input
          type="text"
          size="large"
          value={added_data[index]?.net_weight}
          onChange={(e) => {
            let temp = [...added_data];
            temp[index]["net_weight"] = e.target.value;
            set_added_data(temp);
          }}
          style={{
            fontSize: "24px",
          }}
        />
      ),
    },
    {
      title: <span className="text-lg font-bold">Action</span>,
      key: "Action",
      width: "10%",
      align: "center",
      render: (_, __, index) => {
        return (
          <div className="flex justify-center gap-2">
            {index === 0 && (
              <Button
                type="text"
                icon={<Plus size={20} style={{ color: defaultColors.primary }} />}
                onClick={() => {
                  set_added_data([
                    ...added_data,
                    {
                      container_id: "",
                      tara_weight: "",
                      gross_weight: "",
                      net_weight: "",
                    },
                  ]);
                }}
              />
            )}
            {index !== 0 && (
              <Button
                type="text"
                icon={<Trash2 size={20} style={{ color: defaultColors.error }} />}
                onClick={() => {
                  let temp2 = [...added_data];
                  temp2?.splice(index, 1);
                  set_added_data(temp2);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];

  //####################### Handle Api's######################################################

  const [machine_data, setMachineData] = useState([]);
  const get_all_machine = async () => {
    try {
      await bp_get_machine_by_machine_typ(success_machine_list_get, {
        machine_type_id: operation_data?.machine_id,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_machine_list_get = (res) => {
    setMachineData(res?.data?.data);
  };

  useEffect(() => {
    get_all_machine();
  }, [operation_data]);

  const resetFunction = () => {
    set_machine("");
  };

  return (
    <MainCard darkTitle title="Product" backbutton>
      <div className="space-y-4">
        <Descriptions
          title=""
          bordered
          column={2}
          contentStyle={{
            fontSize: "24px",
          }}
          labelStyle={{
            fontSize: "32px",
            fontWeight: "bold",
          }}
          items={[
            {
              key: "5",
              label: "Instruction",
              children: operation_data?.instruction,
              span: 2,
            },
            {
              key: "1",
              label: "Batch No",
              children: operation_data?.batch_number,
            },
            {
              key: "2",
              label: "Operation",
              children: `${operation_data?.operation_type} - ${operation_data?.operation_number}`,
            },
            {
              key: "3",
              label: "Machine",
              children: (
                <Select
                  value={machine}
                  size="large"
                  placeholder="Select Machine"
                  onChange={(value) => set_machine(value)}
                  style={{
                    width: "100%",
                    fontSize: "24px",
                  }}
                  options={machine_data?.map((item) => ({
                    label: item.machine_name,
                    value: item.machine_id,
                  }))}
                />
              ),
            },
            {
              key: "4",
              label: "Duration",
              children: operation_data?.max_duration,
            },
          ]}
        />

        <DataTable
          data={added_data}
          columns={machineDetailColumns}
          bordered
          pagination={false}
          height={null}
        />

        <div className="flex justify-end items-end gap-2">
          <Button
            type="primary"
            size="large"
            style={{
              backgroundColor: defaultColors.primary,
              borderColor: defaultColors.primary,
              height: "50px",
              fontSize: "24px",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </MainCard>
  );
}

export default Product;
